import React, { useEffect, useState } from "react";
import "./mydocuments.css";
import "../LandingCostCalculator/landingcostcalculator.css";
import docUrl from "../../assets/file-sample_100kB.doc";
import editProfileService from "../../components/Services/editProfile.service";
import UploadedDocument from "./UploadedDocument";
import moment from "moment";
import { useSelector } from "react-redux";
import analystService from "../../components/Services/analyst.service";
import documentUploadService from "../../components/Services/documentUpload.service";
import { toast } from "react-toastify";
import { toastProperties } from "../../commons/Toast/Toaster";
import { CircularProgress, TextField, Menu, MenuItem } from "@mui/material";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import autoMergeLevel1 from "redux-persist/es/stateReconciler/autoMergeLevel1";
import NodataFound from "../../commons/Toast/noDataFound";
const MyDocuments = () => {
 const [selectedFiles, setSelectedFiles] = useState(null);
 const [selectedFileData, setSelectedFileData] = useState(null);
 const [myDocuments, setMyDocuments] = useState([]);
 const [isOpen, setIsOpen] = useState(false);
 const [uploadedDocData, setUploadedDocData] = useState();
 const [commentInput, setCommentInput] = useState();
 const [isCommentModal, setCommentModal] = useState(false);
 const [selectedItem, setSelectedItem] = useState();
 const [documentHistory, setDocumentHistory] = useState(false);
 const [documentHistoryData, setDocumentHistoryData] = useState(null);

 
 let userDetails = JSON.parse(localStorage.getItem("UserDetails"));
 const isLoggedIn = useSelector((state) => state?.sessionState?.role);

 const handleViewFile = (item) => {
  if (myDocuments) {
   let fileTypeSplit = item?.document?.fileName.split(".");
   setSelectedFiles(fileTypeSplit[fileTypeSplit?.length - 1]);
   setSelectedFileData(item?.document?.fileInBytes);
   setIsOpen(true);
  }
 };

 // const handleDownloadFile = (fileName) => {
 //     setSelectedFiles(fileName);
 //     const link = document.createElement('a');
 //     link.href = `${fileName}`;
 //     link.target = '_blank';
 //     link.download = fileName;

 //     document.body.appendChild(link);
 //     link.click();
 //     document.body.removeChild(link);
 // }
 // const handleViewDocFile = () => {
 //     const popupWindow = window.open(docUrl, '_blank', 'width=800,height=600');
 //     if (popupWindow) {
 //         popupWindow.focus();
 //     }
 // }

 const handleCloseModal = () => {
  setIsOpen(false);
 };
 const getMyDocuments = () => {
  editProfileService
   .getMyProfileDocuments()
   .then((response) => {
    if (response?.data?.code === 200) {
     setMyDocuments(response?.data?.data);
    }
   })
   .catch((error) => {
    console.error("Api call Error", error);
   });
 };
 const getUserDocumentsById = (id) => {
  analystService
   .getUserDocumentsById(id)
   .then((response) => {
    if (response?.data?.code === 200) {
     setMyDocuments(response?.data?.data);
    }
   })
   .catch((error) => {
    console.error("Api call Error", error);
   });
 };
 useEffect(() => {
  if (isLoggedIn === "ANALYST") {
   getUserDocumentsById(
    userDetails && (userDetails?.companyId ? userDetails?.companyId : null)
   );
  } else {
   getMyDocuments();
  }
 }, []);

 const handleProofOfPayment = (e, item) => {
  setUploadedDocData(null);
  const fun = async (e) => {
   const fileList = e?.target?.files;
   if (fileList.length > 0) {
    const file = fileList[0];
    let extension = file.name.split(".").pop();
    let fileSize = file.size / 1024 / 1024;
    let extList = ["jpg", "jpeg", "png", "pdf"];
    if (fileSize < 10) {
     if (extList.includes(extension)) {
      let formData = new FormData();
      formData.append("file", file);
      const config = {
       headers: {
        "Content-Type": "multipart/form-data",
       },
      };
      let data = (
       await documentUploadService.documentUpload(
        item[1]?.latest?.document?.type,
        formData,
        config
       )
      )?.data;
      if (data?.data) {
       setUploadedDocData(data);
       setSelectedItem(item);
       setCommentModal(true);
      } else {
       toast.error("Failed to upload File", toastProperties);
      }
     }
    } else {
     toast.error("File Size Cannot Exceed 10mb", toastProperties);
    }
   }
  };
  fun(e);
 };

 const handleNewDocUpload = () => {
  const reqBody = [
   {
    companyId: userDetails?.companyId,
    documentId: uploadedDocData?.data?.id,
    status: "SUBMITTED",
    comment: commentInput,
    uploadedBy: null,
   },
  ];

  analystService.reUploadDocuments(reqBody).then((response) => {
   if (response?.data?.code === 200) {
    setMyDocuments(null);
    setCommentModal(false);
    getUserDocumentsById(
     userDetails && (userDetails?.companyId ? userDetails?.companyId : null)
    );
    toast.success(response?.data?.message, toastProperties);
   }
  });
 };
 const openDocumentHistoryModal = (item) => {
    setDocumentHistoryData(null)
  setDocumentHistory(true);
  if(item?.length > 0){
    setDocumentHistoryData(item)
  }
 };

 const handleClose = (e) => {
  setDocumentHistory(false);
 };
 return (
  <>
   <div>
    {isOpen && (
     <UploadedDocument
      fileData={selectedFileData}
      handleCloseModal={handleCloseModal}
      fileType={selectedFiles}
      isOpen={isOpen}
     />
    )}
   </div>
   {isCommentModal && (
    <Modal show={isCommentModal} size="md" style={{ height: "100%" }}>
     <Modal.Header>
      <Modal.Title>Comment Box</Modal.Title>
     </Modal.Header>
     <Modal.Body className="">
      <p>Add a comment for the file re-uploading</p>
      <TextField
       color="primary"
       minRows={2}
       size="xl"
       variant="outlined"
       onChange={(e) => {
        setCommentInput(e.target.value);
       }}
      />
      <button
       className="btn btn-signup btn-primary"
       style={{ margin: "20px" }}
       type="button"
       onClick={handleNewDocUpload}
      >
       Submit
      </button>
     </Modal.Body>
    </Modal>
   )}
   {documentHistory && (
    <Modal
     show={documentHistory}
     size="xl"
     onHide={handleClose}
     centered
     style={{ height: "100%" }}
    >
     <Modal.Header closeButton>
      <Modal.Title>Document History</Modal.Title>
     </Modal.Header>
     <Modal.Body className="">
      {documentHistoryData ? (
       <div className="table-responsive doc-cus-table mt-3">
        <table className="cus-table table-bordered my-documents-table">
         <thead className="table-header">
          <tr>
           <th>Document Category</th>
           <th>Uploaded On</th>
           <th>Document Name</th>
           <th>View Document</th>
          {isLoggedIn === "ANALYST" && <th>Comments</th>}
          </tr>
         </thead>
         <tbody>
          {documentHistoryData?.map((item, i) => (
            <tr>
             <td>{item?.document?.type}</td>
             <td>{item?.document?.createdAt}</td>
             <td>{item?.document?.fileName}</td>
             <td>
              <span>
               <button
                className="btn-pdf-reader"
                onClick={() => handleViewFile(item)}
               >
                <img src="images/view-icon.png" alt="view" />
               </button>
              </span>
             </td>
             {isLoggedIn === "ANALYST" && (
             <td>{item?.comment ? item?.comment : "NA"}</td>
            )}
            </tr>
           ))}
         </tbody>
        </table>
       </div>
      ) : (
       <div className="text-center" style={{ maxHeight: "500px" }}>
        <NodataFound />
       </div>
      )}
     </Modal.Body>
    </Modal>
   )}
   <div className={isLoggedIn !== "ANALYST" && "container my-4"}>
    <div className={isLoggedIn !== "ANALYST" && "landingcost-card"}>
     {/* <div className='myd-box-title'>My Documents</div> */}
     {myDocuments ? (
      <div className="table-responsive doc-cus-table mt-3">
       <table className="cus-table table-bordered my-documents-table">
        <thead className="table-header">
         <tr>
          <th>Document Category</th>
          <th>Uploaded On</th>
          <th>Document Name</th>
          <th>View Document</th>
          {isLoggedIn === "ANALYST" && <th>Upload New</th>}
          {isLoggedIn === "ANALYST" && <th>Comments</th>}
         </tr>
        </thead>
        <tbody>
         {myDocuments &&
          Object.entries(myDocuments).map((item, i) => (
           <tr key={i}>
            <td>{item[1]?.latest?.document?.type}</td>
            <td>{item[1]?.latest?.document?.createdAt}</td>
            <td>{item[1]?.latest?.document?.fileName}</td>
            <td>
             <div style={{ display: "flex" ,gap:'10px',alignContent:'center',justifyContent:'center'}}>
              {
                    item[1]?.latest && (
                    <span>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>View Latest</Tooltip>}
                    >
                      <button
                      className="btn-pdf-reader"
                      onClick={() => handleViewFile(item[1]?.latest)}
                    >
                      <img src="images/view-icon.png" alt="view" />
                    </button>
                    </OverlayTrigger>
                    
                    </span>
                    )
              }
              <div
               onClick={(e) => {
                openDocumentHistoryModal(item[1]?.history);
               }}
               style={{ cursor: "pointer",marginTop:'5px' }}
              >
               <OverlayTrigger
                placement="top"
                overlay={<Tooltip>View History</Tooltip>}
               >
                <div>
                 <i className="bi bi-clock-history" style={{color:'#FF7D00'}}></i>
                </div>
               </OverlayTrigger>
              </div>
             </div>
            </td>
            {isLoggedIn === "ANALYST" && (
             <td>
              {
               <div className="file-input-wrapper">
                <input
                 type="file"
                 id="file-input1"
                 className=""
                 onChange={(e) => handleProofOfPayment(e, item)}
                />
               </div>
              }
             </td>
            )}
            {isLoggedIn === "ANALYST" && (
             <td>{item[1]?.latest?.comment ? item[1]?.latest?.comment : "NA"}</td>
            )}
           </tr>
          ))}
        </tbody>
       </table>
      </div>
     ) : (
      <div className="text-center" style={{ maxHeight: "500px" }}>
       <CircularProgress />
      </div>
     )}
    </div>
   </div>
  </>
 );
};

export default MyDocuments;
